/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInner } from './get-fraud-locked-card-transaction200-response-one-of-card-transaction-transaction-record-list-inner';

/**
 * 
 * @export
 * @interface GetFraudLockedCardTransaction200ResponseOneOfCardTransaction
 */
export interface GetFraudLockedCardTransaction200ResponseOneOfCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransaction
     */
    'transactionType': GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransaction
     */
    'transactionStatus': GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInner>}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransaction
     */
    'transactionRecordList': Array<GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfCardTransaction
     */
    'isCleared': boolean;
}

export const GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionTypeEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionTypeEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionTypeEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionStatusEnum = {
    success: 'SUCCESS'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionStatusEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionStatusEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfCardTransactionTransactionStatusEnum];


